import { render, staticRenderFns } from "./Lgx177569090745925632.vue?vue&type=template&id=4c303240&"
import script from "./Lgx177569090745925632.vue?vue&type=script&lang=js&"
export * from "./Lgx177569090745925632.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports